import { Row, FormInput, FormTextArea, Col, Widget, FormSwitch, FormCheckbox, Icon, Button, Table, FormContext } from '@digital/ui'
import React, { useContext, useEffect, useState } from 'react'
import ptBR from '@app/i18n/ptBR'
import { Card, Collapse } from 'antd';
import { EContratacaoNecessaria, EMaturidadeEOuNivelDeDefinicao, EStatusSolicitacaoNaoPrevisto, EStepsSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import { useRecoilState, useRecoilValue } from 'recoil';
import { activeStepHashState, orcadoAnoParametroState, reloadState, solicitacaoIdState, solicitacaoState } from '../../../atoms';
import { getBalancoEconomico, updateSolicitacaoNaoPrevisto, updateSolicitacaoNaoPrevistoFinanceiro } from '@app/api/naoPrevistos/solicitacao';
import { Visibility } from '@app/components/Visibility';
import { CurrencyInput3 } from '@app/components/CurrencyInput3';
import ModalAnexos from './ModalAnexos';
import { currencyParser } from '@app/helpers/numbers';

const { Panel } = Collapse;
const Detalhes = () => {
  const { formProps } = useContext(FormContext);
  const [solicitacao, setSolicitacao] = useRecoilState(solicitacaoState);
  const [reload, setReload] = useRecoilState(reloadState);
  const [fornecedor, setFornecedor] = useState('')
  const [balancoEconomico, setBalancoEconomico] = useState({})
  const orcadoAnoParametro = useRecoilValue(orcadoAnoParametroState);
  const solicitacaoId = useRecoilValue(solicitacaoIdState);
  const [activeStepHash, setActiveStepHash] = useRecoilState<string>(activeStepHashState);
  const [enableCurrencyInputs, setEnableCurrencyInputs] = useState(false)
  const [forecastAtualizadoFinanceiro, setForecastAtualizadoFinanceiro] = useState<number | undefined>()
  const [impactoNoForecastFinanceiro, setImpactoNoForecastFinanceiro] = useState<number | undefined>()

  const onUpdateFinanceiroFields = () => {
    updateSolicitacaoNaoPrevistoFinanceiro({
      id: solicitacao.id,
      forecastAtualizadoFinanceiro,
      impactoNoForecastFinanceiro,
    }).then((result) => {
      setReload(!reload)
    })
  }

  const onSwitch = (value: any, property: string) => {
    const values = { ...solicitacao, [property]: value }
    setSolicitacao(values)

    updateSolicitacaoNaoPrevisto(values).then((result) => {
      setReload(!reload)
    })
  }

  const onBlur = (e: any) => {
    console.log({ e })
    if (solicitacao[e.currentTarget.name] === e.currentTarget.value) return

    const values = { ...solicitacao, [e.currentTarget.name]: e.currentTarget.value }

    updateSolicitacaoNaoPrevisto(values).then((result) => {
      setReload(!reload)
    })
  }

  const onBlurCurrency = (e: any) => {
    console.log('xd')
    if (e.target.value === '') {

      const fielsCanNullable = ['forecastDoMes', 'naoPrevistosAprovados', 'impactoNoForecast']
      if (e.target.name === fielsCanNullable) {

        const values = { ...solicitacao, [e.target.name]: 0 }

        updateSolicitacaoNaoPrevisto(values).then((result) => {
          setReload(!reload)
        })

      }
      return
    }

    const value = currencyParser(e.target.value)
    const defaultValue = (solicitacao[e.target.name] ?? '').toString()

    if (value === defaultValue) {
      const values = { ...solicitacao, [e.target.name]: 0 }

      updateSolicitacaoNaoPrevisto(values).then((result) => {
        setReload(!reload)
      })

      return
    }

    const values = { ...solicitacao, [e.target.name]: currencyParser(e.target.value) }

    updateSolicitacaoNaoPrevisto(values).then((result) => {
      setReload(!reload)
    })
  }

  const onSelect = (value: any, property: string) => {
    if (solicitacao[property] === value) return

    const values = { ...solicitacao, [property]: value }

    updateSolicitacaoNaoPrevisto(values).then((result) => {
      setReload(!reload)
    })
  }

  const handleAddFornecedor = () => {
    if (fornecedor === '') {
      formProps && formProps.setFieldError('fornecedor', 'Campo obrigatório')
      return
    }
    let list: string[] = []
    if (solicitacao.fornecedores) {
      list = [...solicitacao.fornecedores]
    }
    list.push(fornecedor)
    const values = { ...solicitacao, fornecedores: list }
    updateSolicitacaoNaoPrevisto(values).then((result) => {
      setFornecedor('')
      setReload(!reload)
    })
  }

  const handleRemoveFornecedor = (item: string) => {
    let list: string[] = []
    if (solicitacao.fornecedores) {
      list = [...solicitacao.fornecedores]
    }
    list = list.filter((i) => i !== item)
    const values = { ...solicitacao, fornecedores: list }

    updateSolicitacaoNaoPrevisto(values).then((result) => {
      setReload(!reload)
    })
  }

  useEffect(() => {
    if (solicitacaoId) {
      getBalancoEconomico(solicitacaoId).then((result) => {
        setBalancoEconomico(result)
        setForecastAtualizadoFinanceiro(result.forecastAtualizadoFinanceiro)
        setImpactoNoForecastFinanceiro(result.impactoNoForecastFinanceiro)
      })
    }
  }, [solicitacaoId, reload])

  useEffect(() => {
    if (EStepsSolicitacaoNaoPrevisto.ValidacaoAdministrador === activeStepHash ||
        EStepsSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao === activeStepHash) {
      setEnableCurrencyInputs(true)
    } else {
      setEnableCurrencyInputs(false)
    }
  }, [activeStepHash])


  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header={ptBR.lblDetalhes} style={{ border: 0 }}>

          <Visibility visible={[EStepsSolicitacaoNaoPrevisto.DefinicaoDoTipoDaSolicitacao].includes(activeStepHash) === false}>
            <Widget
              title=""
              actions={[]}>
              <Row>
                <CurrencyInput3 name='orcamentoAprovado' span={2} label={ptBR.lblOrcamentoAprovado} value={balancoEconomico.orcamentoAprovado} disabled />
                <CurrencyInput3 name='forecastDoMes' span={2} label={ptBR.lblForecastDoMes} onBlur={onBlurCurrency} disabled={!enableCurrencyInputs} />
                <CurrencyInput3 name='naoPrevistosAprovados' span={2} label={ptBR.lblNaoPrevistosAprovados} onBlur={onBlurCurrency} disabled={!enableCurrencyInputs} />
                <CurrencyInput3 name='impactoNoForecast' span={2} label={ptBR.lblImpactoNoForecast} onBlur={onBlurCurrency} disabled={!enableCurrencyInputs} />
                <CurrencyInput3 name='forecastAtualizado' span={2} label={ptBR.lblForecastAtualizado} value={balancoEconomico.forecastAtualizado} disabled />
              </Row>

              <Row>
                <CurrencyInput3 name='impactoNoForecastFinanceiro' span={2} label={ptBR.lblImpactoNoForecastFinanceiro} disabled={activeStepHash !== EStepsSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao} value={impactoNoForecastFinanceiro} onChange={(e) => setImpactoNoForecastFinanceiro(e ? e : 0)} onBlur={onUpdateFinanceiroFields} />
                <CurrencyInput3 name='forecastAtualizadoFinanceiro' span={2} label={ptBR.lblForecastAtualizadoFinaceiro} disabled={activeStepHash !== EStepsSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao} value={forecastAtualizadoFinanceiro} onChange={(e) => setForecastAtualizadoFinanceiro(e ? e : 0)} onBlur={onUpdateFinanceiroFields} />
                {/* {activeStepHash === EStepsSolicitacaoNaoPrevisto.ValidacaoAdministrador && <Button
                  type="default" style={{ marginTop: '22px' }} onClick={onUpdateFinanceiroFields}>
                  Salvar
                </Button>} */}
              </Row>



            </Widget>
          </Visibility>

          <Widget
            title=""
            actions={[]}>

            <Row>
              <FormSwitch
                label={ptBR.lblRfa}
                name="rfa"
                checked={solicitacao.rfa}
                span={2}
                onChange={value => onSwitch(value, 'rfa')}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            </Row>

            <Row>
              <FormSwitch
                label={ptBR.lblEmergencial}
                name="emergencial"
                checked={solicitacao.emergencial}
                span={2}
                onChange={value => onSwitch(value, 'emergencial')}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            </Row>
            <Row>
              <FormSwitch
                label={ptBR.lblTradeOff}
                name="tradeOff"
                checked={solicitacao.tradeOff}
                span={2}
                onChange={value => onSwitch(value, 'tradeOff')}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            </Row>
            <Row>
              <CurrencyInput3
                span={2}
                label={ptBR.lblTaxaUs}
                name='taxaUs'
                value={orcadoAnoParametro.valorDolar}
                disabled
              />

              <CurrencyInput3
                span={2}
                label={ptBR.lblTaxaEuro}
                name='taxaEuro'
                value={orcadoAnoParametro.valorEuro}
                disabled
              />
            </Row>

            <Row>
              <FormCheckbox
                name={"maturidadeEOuNivelDeDefinicao"}
                label={ptBR.lblMaturidadeEOuNivelDeDefinicao}
                value={solicitacao.maturidadeEOuNivelDeDefinicao}
                options={[
                  { text: ptBR.lblEngConceitual, value: EMaturidadeEOuNivelDeDefinicao.EngConceitual },
                  { text: ptBR.LblEngBasica, value: EMaturidadeEOuNivelDeDefinicao.EngBasica },
                  { text: ptBR.LblEngDetalhada, value: EMaturidadeEOuNivelDeDefinicao.EngDetalhada },
                  { text: ptBR.lblConsultivaViaGa, value: EMaturidadeEOuNivelDeDefinicao.ConsultivaViaGa },
                  { text: ptBR.lblDepDeclaracaodoEscopoDoProjeto, value: EMaturidadeEOuNivelDeDefinicao.DepDeclaracaodoEscopoDoProjeto },
                  { text: ptBR.lblOutros, value: EMaturidadeEOuNivelDeDefinicao.Outros },
                ]}
                onChange={(value) => { onSelect(value, 'maturidadeEOuNivelDeDefinicao') }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            </Row>


            <Row>
              <ModalAnexos />
            </Row>
            <Row>

            </Row>
          </Widget>

          <Widget
            title=""
            actions={[]}>
            <Row>

              <FormCheckbox
                name={"contratacaoNecessaria"}
                label={ptBR.lblContratacaoNecessaria}
                value={solicitacao.contratacaoNecessaria}
                options={[
                  { text: ptBR.lblEngenharia, value: EContratacaoNecessaria.Engenharia },
                  { text: ptBR.lblMateriaisEquipamentos, value: EContratacaoNecessaria.MateriaisEquipamentos },
                  { text: ptBR.lblConstrucao, value: EContratacaoNecessaria.Construcao },
                  { text: ptBR.lblOutros, value: EContratacaoNecessaria.Outros },
                ]}
                onChange={(value) => { onSelect(value, 'contratacaoNecessaria') }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            </Row>

            <Row>
              <FormSwitch
                label={ptBR.lblFornecedorDirecionadoSwitch}
                name="fornecedorDirecionado"
                checked={solicitacao.fornecedorDirecionado}
                span={4}
                onChange={value => onSwitch(value, 'fornecedorDirecionado')}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            </Row>

            <Visibility visible={solicitacao.fornecedorDirecionado}>

              <Visibility visible={solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}>
                <Row>
                  <FormInput
                    span={6}
                    label={ptBR.lblFornecedorDirecionado}
                    name='fornecedor'
                    value={fornecedor}
                    onChange={(e) => setFornecedor(e.target.value)}
                    addonAfter={<Icon name='commons-plus' onClick={e => handleAddFornecedor()} />}
                  />
                </Row>
              </Visibility>

              <Row>
                <Col span={6}>
                  <Table
                    dataSource={solicitacao.fornecedores || []}
                    pagination={false}
                    columns={[
                      {
                        title: 'Fornecedor',
                        dataIndex: 'fornecedor',
                        render(text, record, index) {
                          return (
                            <span>{record}</span>
                          )
                        },
                      },
                      {
                        title: 'Ação',
                        dataIndex: 'acao',
                        key: 'acao',
                        width: '5%',
                        render: (text, record, index) =>
                          <>
                            <Visibility visible={solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}>
                              <Button
                                icon="science-minus"
                                onClick={() => handleRemoveFornecedor(record)}
                              />
                            </Visibility>
                          </>
                      },
                    ]}
                  />
                </Col>
              </Row>

            </Visibility>

            <Row>
              <FormTextArea
                label={ptBR.lblObservacao}
                name="observacaoContratacaoNecessaria"
                rows={3}
                span={12}
                onBlur={onBlur}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            </Row>
          </Widget>

        </Panel>
      </Collapse>
    </>
  )
}

export default Detalhes